<template>
    <DefaultLayout :meta="meta">

        <div class="w-full max-w-screen-xl mx-auto px-6 mb-16">
       
            <h1 class="text-2xl font-bold mt-8">
            	{{ page.title }}
            </h1>

            <div class="mt-8" v-html="page.content"></div>

        </div>
        
    </DefaultLayout>
</template>

<script>
    export default {
        props: {
            meta: {
                type: Object,
                default: () => {},
            },
            page: {
                type: Object,
                default: () => {},
            },
        },
    }
</script>